import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "redeem" };
const _hoisted_2 = { class: "illustration" };
const _hoisted_3 = { class: "card card--back" };
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "card card--front" };
const _hoisted_6 = ["src"];
const _hoisted_7 = { class: "redeem-body" };
const _hoisted_8 = { class: "redeem-form" };
const _hoisted_9 = ["src"];
const _hoisted_10 = {
    key: 1,
    class: "status-msg"
};
const _hoisted_11 = {
    key: 2,
    class: "status-msg"
};
const _hoisted_12 = { class: "status-text" };
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import MGTextField from './elements/MGTextField.vue';
import { useAuth } from '@/composables/useAuth';
import { useReferrals } from '@/composables/useReferrals';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RedeemMGMPage',
    setup(__props) {
        useAuth();
        const { applyCode } = useReferrals();
        const router = useRouter();
        const route = useRoute();
        const suffix = ref('');
        const display = computed(() => 'MG-' + suffix.value);
        const submitting = ref(false);
        const codeAccepted = ref(false);
        const errorMsg = ref(null);
        function clear() {
            suffix.value = '';
            errorMsg.value = null;
        }
        function onInput(e) {
            errorMsg.value = null;
            const el = e.target;
            let v = el.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
            while (v.startsWith('MG'))
                v = v.slice(2);
            suffix.value = v.slice(0, 5);
            el.value = suffix.value;
        }
        const MESSAGES = {
            InvalidCode: { title: "We couldn't find that code.", body: 'Please check it and try again.' },
            AlreadyReferred: { title: "Already redeemed.", body: "You've already used a referral code." },
            CodeUsageLimitReached: { title: "Code limit reached.", body: 'This code has reached its usage limit.' },
            BudgetExceeded: { title: "Offer unavailable.", body: 'This offer is fully subscribed right now.' },
            WrongEmployer: { title: "Code not valid.", body: "This code isn't valid for your employer." },
            CustomerCannotReferThemselves: { title: "That's your own code.", body: "You can't redeem your own referral code." },
            ReferrerRefereeNotFound: { title: "Something went wrong.", body: "We couldn't apply that code. Please try again." },
            MGMDisabled: { title: "Not available.", body: "Referrals aren't available right now." },
        };
        const FALLBACK = { title: 'Something went wrong.', body: 'Please try again.' };
        // Test mode: /Redeem?stage=accepted or ?stage=error previews those states without a real code
        const stage = route.query.stage;
        if (stage === 'accepted' || stage === 'error')
            suffix.value = 'TEST1';
        if (stage === 'accepted')
            codeAccepted.value = true;
        if (stage === 'error')
            errorMsg.value = MESSAGES.InvalidCode;
        function redeem() {
            if (!suffix.value || submitting.value)
                return;
            submitting.value = true;
            errorMsg.value = null;
            applyCode(display.value, (result) => {
                submitting.value = false;
                if (result.success) {
                    codeAccepted.value = true;
                }
                else {
                    errorMsg.value = MESSAGES[result.message] ?? FALLBACK;
                }
            }, () => {
                submitting.value = false;
                errorMsg.value = FALLBACK;
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    bgcolor: "transparent",
                    border: 0
                }),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("img", {
                                src: require('@/assets/mgm-card-back.svg'),
                                alt: "",
                                class: "card-art"
                            }, null, 8, _hoisted_4)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("img", {
                                src: require('@/assets/mgm-card-front.svg'),
                                alt: "",
                                class: "card-art"
                            }, null, 8, _hoisted_6)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "redeem-intro" }, [
                            _createElementVNode("h1", { class: "redeem-title" }, "Invited by a colleague?"),
                            _createElementVNode("p", { class: "redeem-subtitle" }, "Enter a colleague’s referral code and you’ll both receive a reward in your Saved to Spend pot.")
                        ], -1)),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["redeem-field", { 'redeem-field--accepted': codeAccepted.value, 'redeem-field--error': errorMsg.value }])
                            }, [
                                _cache[1] || (_cache[1] = _createElementVNode("label", { for: "redeemCode" }, "Invite code", -1)),
                                _createVNode(MGTextField, {
                                    id: "redeemCode",
                                    modelValue: suffix.value,
                                    prefix: "MG-",
                                    placeholder: "xxxxx",
                                    "persistent-placeholder": "",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "",
                                    "single-line": "",
                                    "bg-color": "white",
                                    autocapitalize: "characters",
                                    autocomplete: "off",
                                    disabled: codeAccepted.value,
                                    onInput: onInput
                                }, _createSlots({ _: 2 }, [
                                    (suffix.value && !codeAccepted.value)
                                        ? {
                                            name: "append-inner",
                                            fn: _withCtx(() => [
                                                _createElementVNode("button", {
                                                    class: "clear-btn",
                                                    onClick: clear
                                                }, [
                                                    _createElementVNode("img", {
                                                        src: require('@/assets/close.png'),
                                                        class: "clear-icon",
                                                        alt: "Clear"
                                                    }, null, 8, _hoisted_9)
                                                ])
                                            ]),
                                            key: "0"
                                        }
                                        : undefined
                                ]), 1032, ["modelValue", "disabled"])
                            ], 2),
                            (!codeAccepted.value)
                                ? (_openBlock(), _createBlock(MGButton, {
                                    key: 0,
                                    text: "Redeem code",
                                    fullWidth: true,
                                    noCaps: true,
                                    disabled: !suffix.value || submitting.value,
                                    onClick: redeem
                                }, null, 8, ["disabled"]))
                                : _createCommentVNode("", true),
                            (codeAccepted.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[2] || (_cache[2] = [
                                    _createElementVNode("div", { class: "status-icon status-icon--success" }, "✓", -1),
                                    _createElementVNode("p", { class: "status-text" }, [
                                        _createElementVNode("strong", null, "Code accepted."),
                                        _createTextVNode(" Your reward will be added once your account is set up.")
                                    ], -1)
                                ])))
                                : _createCommentVNode("", true),
                            (errorMsg.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "status-icon status-icon--error" }, "✕", -1)),
                                    _createElementVNode("p", _hoisted_12, [
                                        _createElementVNode("strong", null, _toDisplayString(errorMsg.value.title), 1),
                                        _createTextVNode(" " + _toDisplayString(errorMsg.value.body), 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createVNode(MGButton, {
                                text: codeAccepted.value ? 'Continue' : 'Continue without a code',
                                outline: !codeAccepted.value,
                                arrow: true,
                                fullWidth: true,
                                noCaps: true,
                                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push({ path: '/signin/done' })))
                            }, null, 8, ["text", "outline"])
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
